import React from "react";
import styled from "styled-components";
import { FaTwitter, FaMedium, FaGithub, FaLinkedin } from "react-icons/fa";

const IntroText = styled.p`
  @media screen and (min-width: 500px) {
    font-size: 1.5rem;
  }
`;

const BioContainer = styled.div`
  margin-bottom: 5rem;
  color: #e9f0f5;
`;

const SocialIcons = styled.span`
  font-size: 2.5rem;
  vertical-align: -webkit-baseline-middle;
`;

const SocialLink = styled.a`
  text-decoration: none;
  background-image: none;
  color: #e9f0f5;
  &hover: {
    color: #150074;
  }
  @media screen and (max-width: 400px) {
    font-size: 1.8rem;
  }
`;

const BigText = styled.h1`
  color: #ffffff;
`;

const Bio = () => (
  <BioContainer>
    <BigText>Hi! </BigText>
    <IntroText>
      I am Zameer. I am a Frontend Developer and I{" "}
      <span role="img" aria-label="heart-emoji">
        ❤️
      </span>{" "}
      JavaScript. While my primary work lies on the Frontend, I love to learn
      and work on everything related to the product.
    </IntroText>
    <IntroText>
      In this blog, I mainly write about tech, mostly from what I learn in my
      work and the books & articles that I read.
    </IntroText>
    <IntroText>
      You can find me on{" "}
      <SocialIcons>
        <SocialLink href="https://github.com/zamhaq" target="_blank">
          <FaGithub />
        </SocialLink>{" "}
        <SocialLink
            href="https://www.linkedin.com/in/zameerhaque/"
          target="_blank"
        >
          <FaLinkedin />
        </SocialLink>{" "}
        <SocialLink href="https://twitter.com/haquezameer" target="_blank">
          <FaTwitter />
        </SocialLink>{" "}
        <SocialLink href="https://medium.com/@haque864" target="_blank">
          <FaMedium />
        </SocialLink>
      </SocialIcons>
    </IntroText>
  </BioContainer>
);

export default Bio;
